import { render, staticRenderFns } from "./club-details.vue?vue&type=template&id=3ddebe38&"
import script from "./club-details.vue?vue&type=script&lang=js&"
export * from "./club-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports